import { render, staticRenderFns } from "./test.vue?vue&type=template&id=672331a8&scoped=true"
import script from "./test.vue?vue&type=script&lang=js"
export * from "./test.vue?vue&type=script&lang=js"
import style0 from "@/utils/style/public-style.css?vue&type=style&index=0&id=672331a8&prod&scoped=true&lang=css&external"
import style1 from "./test.vue?vue&type=style&index=1&id=672331a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672331a8",
  null
  
)

export default component.exports